import { createTheme } from '@mantine/core';

export const theme = createTheme({
  fontFamily: 'Sora, -apple-system, sans-serif',
  primaryColor: 'brand',
  defaultRadius: 'sm',

  colors: {
    dark: [
      '#e5e5e5',
      '#b3b3b3',
      '#999999',
      '#808080',
      '#666666',
      '#4d4d4d',
      '#333333',
      '#1c1c1c',
      '#141414',
      '#0a0a0a',
    ],
    brand: [
      '#fdf0f1',
      '#fce1e3',
      '#f8babd',
      '#f2848a',
      '#ea3a43',
      '#e50914',
      '#c00811',
      '#9c060e',
      '#77050a',
      '#520307',
    ],
  },

  components: {
    TextInput: {
      styles: {
        input: {
          '&:focus': {
            borderColor: '#e5e5e5',
            boxShadow: '0 0 0 2px rgba(255, 255, 255, 0.08)',
          },
        },
      },
    },
    Button: {
      defaultProps: {
        size: 'md',
      },
      styles: {
        root: {
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        },
      },
    },
  },
});
